import React, { useEffect, useState } from "react";
import Card from "./Card";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAdminProducts } from "../../../redux/features/product/productSlice";

//use Effect

const Products = () => {
  const dispatch = useDispatch();

  const adminProducts = useSelector(
    (state) => state.products.adminProducts.products
  );

  useEffect(() => {
    // Fetch admin products when the component mounts
    dispatch(getAdminProducts());
  }, [dispatch]);

  return (
    <div className=" px-[10px] md:px-[20px] lg:px-[3%]">
      <Link to="/admin">
        <img className=" h-16" src="/utils/back.png" alt="" />
      </Link>
      <div className="flex flex-wrap justify-center items-start mb-10 md:mb-0">
        {adminProducts &&
          adminProducts.map((product) => (
            <Card key={product._id} product={product} />
          ))}
        {/* {products &&
          products.map((product) => (
            <Card key={product._id} product={product} />
          ))} */}
      </div>
    </div>
  );
};

export default Products;
